import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SpotterSpinnerComponent } from "@spotter/components/layout/spotter-spinner/spotter-spinner.component";
import { SafeHtmlPipe } from '@spotter/pipes/safe-html-pipe';

@Component({
    selector: 'front-page-widget',
    templateUrl: './front-page.widget.html',
    standalone: true,
    imports: [FontAwesomeModule, SafeHtmlPipe],
    styleUrl: './front-page.widget.scss'
})
export class FrontPageWidget implements OnInit, OnChanges {
    @Input() title!: string;
    @Input() value?: number | string;
    @Input() icon!: string;


    animatedNumber: number = 0;
    duration: number = 1000;

    targetNumber = 0;
    suffix = "";
    displayString = "-";

    ngOnInit(): void {

    }

    ngOnChanges(): void {
        this.animateNumber();
    }

    animateNumber(): void {
        if (this.value)
        {
            const startTime = performance.now();

            if (typeof this.value === 'number')
            {
                this.targetNumber = this.value;
            }
            else if (typeof this.value === 'string')
            {
                const match = this.value.match(/^([\d,.]+)\s*(.*)$/);
                if (match)
                {
                    this.targetNumber = parseFloat(match[1].replace(',', '')); // handle commas
                    this.suffix = match[2].trim();
                }
            }



            const updateNumber = (timestamp: number) => {
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / this.duration, 1);
                this.updateDisplay(this.targetNumber! * progress);

                if (elapsed < this.duration)
                    requestAnimationFrame(updateNumber);
                else
                    this.updateDisplay(this.targetNumber);

            };

            requestAnimationFrame(updateNumber); // Start the animation
        }

    }

    updateDisplay(number: number) {
        this.animatedNumber = Math.floor(number);
        this.displayString = `${this.animatedNumber}<small>${this.suffix}</small>`;
    }

}
